import { FunctionComponent, ReactNode, useEffect, useState } from "react";
import styles from "./MenuSideBar.module.css";
import { useFocusHandling } from "../../../hooks/useFocusHandling";
import { BadgeNotification } from "../../../components/badge/BadgeNotification";

export type MenuSideBarAtomType = {
  className?: string;

  /** Variant props */
  icon: ReactNode;
  iconSelected?: ReactNode;
  isSelected: boolean;
  label?: string;
  badgeLabel?: string;
  direction?: "row" | "column";
  expanded?: boolean;
  onClick?: () => void;
};

const MenuSideBarAtom: FunctionComponent<MenuSideBarAtomType> = ({
  className = "",
  icon,
  iconSelected,
  isSelected: externalIsSelected = false,
  label = "",
  badgeLabel = "",
  direction = "column",
  expanded = true,
  onClick,
}) => {
  const [showBadge, setShowBadge] = useState(true);
  const [isFocused, setIsFocused] = useState(false);
  const [isSelected, setIsSelected] = useState(externalIsSelected);
  const { handleFocus, handleBlur } = useFocusHandling({
    isDisabled: false,
    setHighlight: setIsFocused,
    onEnter: () => {
      handleClick();
    },
  });

  const handleClick = () => {
    setIsSelected(true);
    setShowBadge(false);
    onClick?.();
  };

  useEffect(() => {
    if (badgeLabel && badgeLabel !== "") {
      setShowBadge(true);
    }
  }, [badgeLabel]);

  useEffect(() => {
    setIsSelected(externalIsSelected);
  }, [externalIsSelected]);

  return (
    <div
      className={[
        styles.root,
        className,
        "quill-ui-next-atom quill-ui-next-pointer",
        "quill-ui-next-no-select",
      ].join(" ")}
      data-is-selected={isSelected ? "yes" : "no"}
      data-direction={direction}
      tabIndex={0}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onClick={handleClick}
    >
      <div className={styles.iconContainer}>
        {direction === "column" && (
          <>
            {isFocused && <div className={styles.bgFocus} />}
            {showBadge && badgeLabel !== "" && (
              <div className={styles.badgeNotification}>
                <BadgeNotification size="sm" label={badgeLabel} />
              </div>
            )}
          </>
        )}
        {isSelected ? iconSelected || icon : icon}
      </div>
      {label && (
        <div className={styles.label}>
          {label}
        </div>
      )}
      {direction === "row" && (
        <>
          {isFocused && <div className={styles.bgFocus} />}
          {showBadge && badgeLabel !== "" && (
            <div
              className={`${styles.badgeContainer} ${
                !expanded && styles.badgeContainerCompress
              }`}
            >
              <BadgeNotification size="sm" label={badgeLabel} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MenuSideBarAtom;
